import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Table, Input } from 'reactstrap';
import { Button } from 'reactstrap';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from 'moment';
import {
    FormGroup,
    Label,
} from 'Actions';

import AppConfig from 'Constants/AppConfig';
import RctCollapsibleCard from 'Components/RctCollapsibleCard/RctCollapsibleCard';
import { CarouselProvider, Slider, Slide, ButtonBack, ButtonNext, Dot } from 'pure-react-carousel';
import { editCaptoReport, allPuttingEvaluationlist, allStudents } from 'Actions';

class EditForm extends React.Component {
    static propTypes = {
        classes: PropTypes.object,
        prev: PropTypes.func,
    };
    async componentDidMount() {
        await this.props.allPuttingEvaluationlist();
        this.setupInitialData();
    }
    constructor(props) {
        super(props);
        this.state = {
            seldate: '',
            studentName: '',
            studentID : '',
            reportname: '',
            selectedFile: [],
            totputt: 0,
            olddate:'',
            observations: [],
            heightProportion: 1600,
            widthProportion: 500
        };
    }

    async componentDidMount() {
        await this.props.allPuttingEvaluationlist();
        this.setupInitialData();
    }

    setupInitialData = () => {
        const { particularcaptoreport, puttingevaluationlist } = this.props;
        
        const defaultDate = particularcaptoreport.length > 0 ? moment(particularcaptoreport[0].cdate, "Do MMMM YYYY").toDate() : new Date();
        const defaultStudentName = particularcaptoreport.length > 0 ? particularcaptoreport[0].student || '' : '';
        const defaultReportName = particularcaptoreport.length > 0 ? particularcaptoreport[0].tsr_reportname || '' : '';
        const studentid=particularcaptoreport.length > 0 ? particularcaptoreport[0].tsr_userID || '' : '';
        const lessons = puttingevaluationlist.map((item, index) => ({
            lesson: item.gteID,
            observation: particularcaptoreport[index]?.tsr_observation || ''
        }));

        this.setState({
            seldate: defaultDate,
            studentID: studentid,
            studentName: defaultStudentName,
            reportname: defaultReportName,
            totputt: lessons.length,
            observations: lessons,
            olddate:defaultDate
        });
    };
    selectdate = (date) => {
        this.setState({ seldate: date });
    }

    handleStudentInputChange = (e) => {
        const { value, name } = e.target;
        this.setState({ [name]: value });
    };

    onFileChange(event) {
        const files = event.target.files;
        for (let i = 0; i < files.length; i++) {
            const element = files[i];
            this.convertBase64(element).then((result) =>
                this.setState({
                    selectedFile: [...this.state.selectedFile, result],
                })
            );
        }
    }


    convertBase64 = (file) => {
        return new Promise((resolve, reject) => {
            const fileReader = new FileReader();
            fileReader.readAsDataURL(file);
            fileReader.onload = () => {
                resolve(fileReader.result);
            };
            fileReader.onerror = (error) => {
                reject(error);
            };
        });
    };

    handleFormSubmit = async (event) => {
        event.preventDefault();
        const { particularcaptoreport } = this.props;
        const target = this.state.totputt;
        const data = {
            student: this.state.studentID,
            date: moment(new Date(this.state.seldate)).format('yyyy-MM-DD'),
            fileupl: this.state.selectedFile,
            reportname: this.state.reportname,
            totput: String(target),
            olddate : moment(new Date(this.state.olddate)).format('yyyy-MM-DD'),
        };

        if (particularcaptoreport && particularcaptoreport.length > 0) {
            for (let i = 1; i <= target; i++) {
                const lessonKey = `lesson_${i}`;
                const observationKey = `obervat_${i}`;
                const lesson = String(this.state.observations[i - 1]?.lesson) || '';
                const observation = String(this.state.observations[i - 1]?.observation) || '';
                data[lessonKey] = lesson;
                data[observationKey] = observation;
            }

            if (this.props.particularcaptoreport.length > target) {
                for (let i = target; i < this.props.particularcaptoreport.length; i++) {
                    const lessonKey = `lesson_${i + 1}`;
                    const observationKey = `obervat_${i + 1}`;
                    const nextLesson = String(this.props.particularcaptoreport[i]?.tsr_lesson) || '';
                    const nextObservation = String(this.props.particularcaptoreport[i]?.tsr_observation) || '';
                    data[lessonKey] = nextLesson;
                    data[observationKey] = nextObservation;
                }
            }

            data.oldfiles = particularcaptoreport[0]?.tsr_filename || '';
            this.props.editCaptoReport(data);
            setTimeout(() => {
                this.props.onClick();
            }, 2000);
        } else {
            console.error('particularcaptoreport is empty or undefined');
        }
    };

    render() {
        const { puttingevaluationlist, particularcaptoreport, loading } = this.props;
        const { studentName, seldate, reportname, widthProportion, heightProportion } = this.state;
        let exfiles = [];
        let filecnt = 0;

        if (particularcaptoreport && particularcaptoreport.length > 0 && particularcaptoreport[0].tsr_filename) {
            const allfile = particularcaptoreport[0].tsr_filename;

            if (allfile !== '') {
                exfiles = allfile.split(',');
                filecnt = exfiles.length;
            }
        }
        const styles = {
            subheading: {
                fontWeight: 'bold',
            },
        };

        return (
            <div>
                <div className="col-md-12">
                    <div className="row">
                        <div className="col-sm-12 col-md-4">
                            <RctCollapsibleCard heading="Create Report Edit">
                                <div className="float-right">
                                    <button type="button" className="mr-3 mb-3 btn btn-outline-warning " onClick={this.props.onClick}>Back</button>
                                </div>
                                <div className="table-responsive">
                                    <Table hover bordered striped>
                                        <tbody>
                                            <tr>
                                                <td>STUDENT</td>
                                                <td style={styles.subheading}>
                                                    <Input
                                                        type="text"
                                                        value={studentName}
                                                        name="student"
                                                        disabled
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>DATE</td>
                                                <td style={styles.subheading}>
                                                    <DatePicker
                                                        className="form-control"
                                                        id="seldate"
                                                        name="seldate"
                                                        autoComplete="off"
                                                        required
                                                        selected={this.state.seldate}
                                                        onChange={this.selectdate}
                                                        dateFormat='yyyy-MM-dd'
                                                        peekNextMonth
                                                        showMonthDropdown
                                                        showYearDropdown
                                                        dropdownMode="select"
                                                    />
                                                </td>
                                            </tr>
                                            {puttingevaluationlist.map((lumbval, idx) => (
                                                <tr key={idx}>
                                                    <td style={{ fontWeight: 'bold' }}>{lumbval.gte_name}</td>
                                                    <td>
                                                        <textarea
                                                            rows="2"
                                                            type="text"
                                                            name={`obervat_${idx + 1}`}
                                                            id={`obervat_${idx + 1}`}
                                                            className="form-control form-control-alternative"
                                                            value={this.state.observations[idx]?.observation || ''}
                                                            onChange={(e) => {
                                                                const { value } = e.target;
                                                                const updatedObservations = [...this.state.observations];
                                                                updatedObservations[idx] = { ...updatedObservations[idx], observation: value };
                                                                this.setState({ observations: updatedObservations });
                                                            }}
                                                        ></textarea>
                                                        <input
                                                            type="hidden"
                                                            name={`lesson_${idx + 1}`}
                                                            id={`lesson_${idx + 1}`}
                                                            value={lumbval.gteID}
                                                        />
                                                    </td>
                                                </tr>
                                            ))}
                                            <tr>
                                                <td>Report Name</td>
                                                <td style={styles.subheading}>
                                                    <Input
                                                        type="text"
                                                        value={reportname}
                                                        name="reportname"
                                                        onChange={this.handleStudentInputChange}
                                                    />
                                                </td>
                                            </tr>
                                            <tr>
                                                <td>File Upload</td>
                                                <td style={styles.subheading}>
                                                    <Input
                                                        type="file"
                                                        name="fileUpload"
                                                        id="fileUpload"
                                                        onChange={(e) => this.onFileChange(e)}
                                                        multiple
                                                    />
                                                </td>
                                            </tr>

                                        </tbody>
                                    </Table>
                                </div>
                                <div className="col-md-12">
                                    <div className="form-group">
                                        <input type="hidden" name="totputt" id="totputt" value={particularcaptoreport && particularcaptoreport.length}></input>
                                        <Button onClick={this.handleFormSubmit} className="mr-3 mb-3 btn btn-outline-primary">
                                            Submit
                                        </Button>
                                    </div>
                                </div>
                            </RctCollapsibleCard>
                        </div>
                        <div className="col-sm-12 col-md-8" ref={this.nodeRef}>
                            <CarouselProvider
                                naturalSlideWidth={this.state.widthProportion}
                                naturalSlideHeight={this.state.heightProportion}
                                totalSlides={filecnt}
                            >
                                <div className="sdfsdf">
                                    <div className="text-center" style={{ marginTop: "-30px" }}>
                                        {exfiles.map((uptval, idx) => (
                                            <Dot className="text-center" slide={idx}>{idx + 1}</Dot>
                                        ))}
                                    </div>
                                </div>
                                <Slider>
                                    {exfiles.map((uptval, idx) => (
                                        <Slide index={idx}>
                                            <RctCollapsibleCard>
                                                <iframe src={AppConfig.apiurl + '/theme/img/capto/' + uptval} width="100%" height={600}></iframe>
                                            </RctCollapsibleCard>
                                        </Slide>
                                    ))}
                                </Slider>
                            </CarouselProvider>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = ({ mostlyused, captoreport }) => {
    const { studentlists, puttingevaluationlist, loading } = mostlyused;
    const { particularcaptoreport } = captoreport;
    return {
        studentlists,
        puttingevaluationlist,
        particularcaptoreport,
        loading
    };
};

export default connect(mapStateToProps, { editCaptoReport, allPuttingEvaluationlist })(EditForm);
